module.exports = __webpack_public_path__ + "static/media/DinningArea-c-f.9452fc2c.webp";